/* Peak Labs - window.PLClamp: clamps long PDP text to ~3 lines with a "View more" toggle
   (only shows the toggle when the text actually overflows). Used to keep the vial/pen
   product pages the same length as the spray page. Reads React. */
(function () {
  if (typeof window === "undefined" || !window.React) return;
  var h = React.createElement;
  var useEff = React.useLayoutEffect || React.useEffect;
  window.PLClamp = function (props) {
    var text = props.text || "";
    var st = React.useState(false), open = st[0], setOpen = st[1];
    var ov = React.useState(false), over = ov[0], setOver = ov[1];
    var ref = React.useRef(null);
    useEff(function () {
      var el = ref.current; if (!el) return;
      setOver(el.scrollHeight > el.clientHeight + 2);
    }, [text]);
    return h("div", { className: "pdp__desc-wrap" },
      h("p", { ref: ref, className: (props.className || "pdp__desc") + (open ? "" : " pdp__desc--clamp") }, text),
      (over || open) ? h("button", { type: "button", className: "pdp__more", onClick: function () { setOpen(!open); } }, open ? "View less" : "View more") : null);
  };
})();
